import Vue from 'vue';
import VueFusionCharts from 'vue-fusioncharts';
import FusionCharts from 'fusioncharts';
import Line from 'fusioncharts/fusioncharts.charts'
import ExcelReport from 'fusioncharts/fusioncharts.excelexport'
import FusionTheme from 'fusioncharts/themes/fusioncharts.theme.fusion';

Vue.use(VueFusionCharts, FusionCharts, Line, FusionTheme, ExcelReport);
